module.exports = __webpack_public_path__ + "static/img/1077_small.0fc16d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1077_small.png
// module id = gYUm
// module chunks = 1